import logger from '@/app/logger';
import axios from 'axios';
import { CustomError } from '@/utils/errors';
import type { LandingPageResponseType } from '@/types/schemaTypes';

/**
 * Landing page queries
 */
export const landingPagesQuery_Client = async (section?: string): Promise<LandingPageResponseType> => {
  const url = '/api/cms/landingpages' + (section ? `/${section}` : '');
  logger.info(`Fetching landing pages data... url: ${url}`);
  return axios
    .get<LandingPageResponseType>(url)
    .then((res) => {
      if (!res?.data) {
        return Promise.reject(new CustomError('No data returned from landing page response. Section: ' + section, 500));
      }
      logger.info(`Got landingpage query response. Section: ${section}`);
      const data = res.data;
      if (!data) {
        return Promise.reject(new CustomError('No landing page data for the section: ' + section, 500));
      }
      return data;
    })
    .catch((err: unknown) => {
      logger.info('Got error: ', err);
      return Promise.reject(err);
    });
};
